import {createFeatureSelector, createSelector} from '@ngrx/store';
import {GroupDetailsState} from './group-details.reducer';

// Selector functions
const groupDetailsData = createFeatureSelector<GroupDetailsState>('ss-cord.group-details');

export const clientFilter = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.clientFilter
);

export const groupStatusFilter = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.groupStatusFilter
);

export const measurementsFilter = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.measurementsFilter
);

export const coachesFilter = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.coachesFilter
);

export const autoGeneratedGroupName = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.autoGenerateGroupName
);

export const verifyGroupName = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.verifyGroupName
);

export const groupDetails = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.groupDetails
);

export const groupDetailsLoading = createSelector(groupDetailsData,(state: GroupDetailsState)=>state.groupDetails.loading)

export const sessionList = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.sessionList
);

export const duplicateGroup = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.duplicateGroup
);

export const groupName = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.groupName
);

export const clientDetails = createSelector(
  groupDetailsData,
  (state: GroupDetailsState) => state.clientDetails?.details
);
